import { render, staticRenderFns } from "./DowloadImage.vue?vue&type=template&id=3a6c6ad6&scoped=true&"
import script from "./DowloadImage.vue?vue&type=script&lang=ts&"
export * from "./DowloadImage.vue?vue&type=script&lang=ts&"
import style0 from "./DowloadImage.vue?vue&type=style&index=0&id=3a6c6ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c6ad6",
  null
  
)

export default component.exports